import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-book-city",
  "use": "icon-book-city-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-book-city\"><path d=\"M851.0028125 182.975a66.4828125 66.4828125 0 0 0-66.4828125-66.4828125H239.4725a66.294375 66.294375 0 0 0-66.4828125 65.5415625l-37.666875 659.1796875a66.4828125 66.4828125 0 0 0 66.4828125 66.294375h620.38125a66.67125 66.67125 0 0 0 66.48375-67.6125z m-28.815 686.865H201.805625a28.8159375 28.8159375 0 0 1-28.8159375-27.87375l37.6678125-659.17875a29.0034375 29.0034375 0 0 1 28.815-28.6275h545.0475a29.191875 29.191875 0 0 1 28.8159375 29.945625l37.666875 656.919375a29.0034375 29.0034375 0 0 1-28.815 28.815z\" /><path d=\"M679.05125 307.278125a18.834375 18.834375 0 0 0-18.834375 18.8334375 148.2215625 148.2215625 0 0 1-296.44125 0 18.834375 18.834375 0 0 0-37.6678125 0 185.8884375 185.8884375 0 0 0 371.776875 0 18.834375 18.834375 0 0 0-18.8334375-18.834375z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/book-city.svg
// module id = jPa9
// module chunks = 65